import styled from "styled-components";
import logo from "../../assets/metodo-billings-logo-dashboard.png";

export const Container = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    align-content: center;
    font-size: 0.66rem;
    flex-direction: column;
    color: var(--pink);

    div.lds-circle {
        display: inline-block;
        transform: translateZ(1px);
    }
    div.lds-circle > div {
        background: url(${logo}) no-repeat center;
        display: inline-block;
        width: 64px;
        height: 64px;
        margin: 0px;
        border-radius: 50%;
        opacity: 0.8;
        animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }
    @keyframes lds-circle {
        0%, 100% {
        animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
        }
        0% {
        transform: rotateY(0deg);
        }
        50% {
        transform: rotateY(1800deg);
        animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
        }
        100% {
        transform: rotateY(3600deg);
        }
    }

`